import * as React from 'react';
import { SVGProps } from 'react';

const IconUserSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 7c1.657 0 3-1.843 3-3.5S10.5 0 8 0 5 1.843 5 3.5 6.343 7 8 7zm0 2c-5.444 0-7 1-7 6h14c0-5-1.556-6-7-6z" />
  </svg>
);
export default IconUserSizeS;
